import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import { societyBenefits } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/links";

export default function SocietySection() {
  return (
    <section id="sociedad" className="relative overflow-hidden bg-background-100">
      <div className="gradient-lilac pointer-events-none absolute inset-0 opacity-70" />
      <div className="pointer-events-none absolute -left-24 top-24 h-[380px] w-[380px] rounded-full glow-lilac blur-3xl" />
      <div className="pointer-events-none absolute -right-20 bottom-16 h-[360px] w-[360px] rounded-full glow-rose blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
          <Reveal className="lg:col-span-5">
            <Eyebrow>Unidad 05 · Sociedad ALÉA</Eyebrow>
            <h2 className="mt-3 font-heading text-4xl font-bold leading-[1.05] text-foreground-950 md:text-5xl">
              Una comunidad para cosmetólogas que crecen juntas
            </h2>
            <p className="mt-5 max-w-md text-[15px] leading-relaxed text-foreground-600">
              Espacio exclusivo para profesionales en Culiacán que quieren formarse, colaborar y
              acceder a beneficios pensados para su negocio.
            </p>
            <a
              href={buildWhatsAppLink("Hola ALÉA, quiero pertenecer a Sociedad ALÉA.")}
              target="_blank"
              rel="noreferrer"
              className="cta-primary mt-8 inline-flex min-h-[48px] items-center gap-2 whitespace-nowrap rounded-[16px] bg-primary-500 px-6 font-label text-[11px] font-semibold uppercase tracking-[0.14em] text-background-50 transition-all duration-300 hover:bg-primary-600"
            >
              Quiero pertenecer
              <i className="ri-arrow-right-line" />
            </a>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-7">
            <div className="card-soft-lg h-[260px] w-full overflow-hidden rounded-[28px] bg-background-100 md:h-[360px]">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20clean%20editorial%20photo%20of%20a%20group%20of%20professional%20women%20beauty%20specialists%20in%20modern%20neutral%20outfits%20standing%20in%20a%20bright%20minimal%20studio%20with%20warm%20natural%20light%2C%20modern%20professional%20community%2C%20fresh%20and%20elegant%2C%20no%20text&width=1400&height=900&seq=aleaW-society&orientation=landscape&nocache=true"
                alt="Comunidad profesional de cosmetólogas de Sociedad ALÉA"
                title="Sociedad ALÉA comunidad profesional cosmetólogas Culiacán"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {societyBenefits.map((benefit, index) => (
            <Reveal
              key={benefit.text}
              delay={(index % 3) * 70}
              className="group flex items-center gap-4 rounded-[20px] border border-secondary-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-accent-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full tone-lilac-surface">
                <i className={`${benefit.icon} text-lg`} />
              </span>
              <span className="text-sm leading-snug text-foreground-700">{benefit.text}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}